module.exports = __webpack_public_path__ + "static/media/hk_logo_full_staging.490d5bcb.png";